export const GridHeight = '100%';
export const GridWidth = '100%';

export const Width_1000 = 1000;
export const Width_5 = 5;
export const Width_20 = 20;
export const Width_30 = 30;
export const Width_40 = 40;
export const Width_80 = 80;
export const Width_50 = 50;
export const Width_85 = 85;
export const Width_100 = 100;
export const Width_120 = 120;
export const Width_130 = 130;
export const Width_150 = 150;
export const Width_160 = 160;
export const Width_170 = 170;
export const Width_195 = 195;
export const Width_200 = 200;
export const Width_210 = 210;
export const Width_230 = 230;
export const Width_300 = 300;
export const Width_350 = 350;
export const Width_400 = 400;
export const Width_600 = 600;
export const Width_550 = 550;
export const Width_500 = 500;
export const Width_250 = 250;
export const Width_280 = 280;
export const Length_30 = 30;
export const Length_10 = 10;
export const Length_8 = 8;
export const Length_4 = 4;
export const Length_255 = 255;
export const BorderColor = '#D6D2D0';
